import axios from 'axios';

export const switchUserHandler = ({username, userGroup, reset}: { username?: string, userGroup?: string, reset?: boolean }) => {
	axios.post("../json/evoAppsUserInfoDialogController/switch-alternative-user", {username, userGroup, reset}).then(
		(response) => {
			setTimeout(
				() => {
					window.location.replace(response.data);
					//ie does not reload if the location replaced is the same as currently active
					window.location.reload(); // reload manually if not already loading redirected page
				}, 500)
		},
	).catch(function () {
		alert("Fehler beim Übertragen der Daten. Bitte laden Sie die Seite erneut.");
	});
};